import { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Tooltip, Tab } from '@mui/material'
import { Link } from 'react-router-dom'
import { colors } from '@global/constants'

interface StyleProps {
  opened: boolean
}

const Label = styled.span<StyleProps>`
  white-space: nowrap;
  transition: all 200ms ease-in;
  transition-delay: 400;
  opacity: ${props => (props.opened ? 1 : 0)};
`

const UnseenDraftsIndicator = styled.span`
  display: inline-block;
  background: ${colors.green.main};
  height: 8px;
  width: 8px;
  border-radius: 4px;
  margin: 0 4px;
`

interface Props {
  opened: boolean
  title: string
  to: string
  value?: string
  badge?: ReactElement | null
  hasUnseenDrafts?: boolean
  hidden?: boolean
  icon?: ReactElement
}

export const LinkTab = ({
  opened,
  title,
  to,
  badge = null,
  hasUnseenDrafts = false,
  hidden = false,
  ...props
}: Props) => {
  return (
    <Tooltip placement="right" title={title}>
      <Link to={to} hidden={hidden} replace>
        <Tab
          label={
            <Label opened={opened}>
              {badge ?? title}
              {hasUnseenDrafts && <UnseenDraftsIndicator />}
            </Label>
          }
          {...props}
        />
      </Link>
    </Tooltip>
  )
}
